export const DATA_HOOKS = {
  hiddenAvatarCount: 'hidden-avatar-count',
  avatar: 'avatar',
  textButton: 'text-button',
};
